export default __webpack_public_path__ + "static/media/page16.bd2c0766.webp";